import React, { useEffect } from "react";
import { useState, useContext } from "react";
import { Link, useNavigate } from "react-router-dom";
import { ClipLoader } from "react-spinners";
import CryptoJS from 'crypto-js'; // Import crypto-js

import WelcomePageBanner from "../../assets/images/WelcomePageBanner.png";
import { FaPlay } from "react-icons/fa";
import { AuthContext } from "../../Context/UserContext";
import axiosClient from "../../axios-client";

function SignIn() {
  const { user, setUser, setToken, updateUser } = useContext(AuthContext);
  const navigate = useNavigate();

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [ErrorMessage, setErrorMessage] = useState("");
  const [loader, setLoader] = useState(false);
  const [isLoading, setIsLoading] = useState(false)
  const [showPassword, setShowPassword] = useState(false);
  const [rememberMe, setRememberMe] = useState(false);

  // const [message, setMessage] = useState('')
  const secretKey = process.env.REACT_APP_SECRET_KEY; 
  useEffect(() => {
    // Check if credentials are saved in localStorage and set them as defaults
    const savedEmail = localStorage.getItem('EM');
    if (savedEmail) {
      setEmail(savedEmail); // Set the saved email in the input
    }
    
    const savedEncryptedPassword = localStorage.getItem('PW');
    if (savedEncryptedPassword) {
      // Decrypt the password stored in localStorage
      const decryptedPassword = CryptoJS.AES.decrypt(savedEncryptedPassword, secretKey).toString(CryptoJS.enc.Utf8);
      setPassword(decryptedPassword); // Set the decrypted password in the input
    }
  }, []);

  const onSubmit = ev => {
    // ev.preventDefault()
    setIsLoading(true)
    const payload = {
      email,
      password,
    }
    const encryptedPassword = CryptoJS.AES.encrypt(password, secretKey).toString();
    axiosClient.post('token/client/', payload)
      .then(({ data }) => {
        setToken(data.access);
        setIsLoading(false);
        // localStorage.setItem("ACCESS_TOKEN", data.access)
        // localStorage.setItem("role", data.role)
        // updateUser()
        if (rememberMe) {
          localStorage.setItem('EM', email);
          localStorage.setItem('PW', encryptedPassword); // Store the encrypted password
        }
        axiosClient
          .get("auth/user/")
          .then(({ data }) => {
            setUser(data);
            if (!data.has_active_subscription) {
              navigate('/abonnement')
            } else navigate('/profile')
          })
          .catch((err) => {
            
            // console.error(err);
          });


      })
      .catch((err) => {
        const response = err.response;

        if (response.data.message === "Votre compte est désactivé") { setErrorMessage(response.data.message); }
        else
          setErrorMessage('Email ou mot de passe incorrect');

        setIsLoading(false)
        // console.error("error: ", err);
      })

  }
  return (
    <section
      className="h-[100vh] "
      style={{
        background: `url(${WelcomePageBanner})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <div className="h-[100vh] flex flex-col  items-center justify-center px-6 py-8 mx-auto md:h-screen lg:py-0">
        <div className=" w-full bg-black/10 backdrop-blur-md rounded-lg shadow sm:my-0 md:mt-0 sm:max-w-md xl:p-0 ">
          <div className="p-6 space-y-4 md:space-y-6 sm:p-12">
            <h1 className=" text-center text-xl font-semibold leading-tight tracking-tight py-3 text-white md:text-3xl dark:text-white">
              S'identifier
            </h1>

            <div
              className="space-y-4 md:space-y-6"
            >
              <div>
                {/* <label
                      for="email"
                      className="block mb-2 text-sm font-medium text-white dark:text-white"
                    >
                      Your email
                    </label> */}
                <input
                  type="email"
                  name="email"
                  value={email}
                  id="email"
                  className={
                    ErrorMessage
                      ? "bg-white/10 backdrop-blur text-white sm:text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-3.5 border-2 border-red-700  dark:placeholder-white dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 placeholder:text-gray"
                      : "bg-white/10 backdrop-blur text-white sm:text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-3.5 dark:placeholder-gray dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 placeholder:text-gray"
                  }
                  placeholder="Email"
                  required=""
                  onChange={(e) => setEmail(e.target.value)}
                ></input>
              </div>
              <div className="relative">
                <input
                value={password}
                  id="hs-toggle-password"
                  type={showPassword ? "text" : "password"}
                  name="password"
                  placeholder="Mot de passe"
                  className={
                    ErrorMessage
                      ? "bg-white/10 backdrop-blur text-white sm:text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-3.5 border-2 border-red-700 dark:bg-gray-700 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 placeholder:text-gray"
                      : "bg-white/10 backdrop-blur text-white sm:text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-3.5 dark:text-gray dark:focus:ring-blue-500 dark:focus:border-blue-500 placeholder:text-gray"
                  }
                  required
                  onChange={(e) => setPassword(e.target.value)}
                />

                {/* Toggle Password Button */}
                <button
                  type="button"
                  onClick={() => setShowPassword(!showPassword)}
                  className="absolute inset-y-0 end-0 flex items-center z-20 px-3 cursor-pointer text-gray-400 rounded-e-md focus:outline-none focus:text-gray-500 dark:text-neutral-600 dark:focus:text-gray-500"
                >
                  {showPassword ? (
                    // Eye Icon (Password Visible)
                    <svg
                      className="shrink-0 size-5"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="#6b7280"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="M2 12s3-7 10-7 10 7 10 7-3 7-10 7-10-7-10-7Z"></path>
                      <circle cx="12" cy="12" r="3"></circle>
                    </svg>
                  ) : (
                    // Eye Slash Icon (Password Hidden)
                    <svg
                      className="shrink-0 size-5"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="#6b7280"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="M9.88 9.88a3 3 0 1 0 4.24 4.24"></path>
                      <path d="M10.73 5.08A10.43 10.43 0 0 1 12 5c7 0 10 7 10 7a13.16 13.16 0 0 1-1.67 2.68"></path>
                      <path d="M6.61 6.61A13.526 13.526 0 0 0 2 12s3 7 10 7a9.74 9.74 0 0 0 5.39-1.61"></path>
                      <line x1="2" x2="22" y1="2" y2="22"></line>
                    </svg>
                  )}
                </button>
              </div>
              <div>
                {ErrorMessage && (
                  <h1 className="flex text-white font-bold p-3 bg-red-500 rounded text-center">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      strokeWidth={1.5}
                      stroke="currentColor"
                      className="w-6 h-6 mr-1"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M12 9v3.75m9-.75a9 9 0 11-18 0 9 9 0 0118 0zm-9 3.75h.008v.008H12v-.008z"
                      />
                    </svg>
                    {ErrorMessage}
                  </h1>
                )}
              </div>
              <div className="flex items-center justify-between">
                <div className="flex items-start">
                  <div className="flex items-center h-5">
                    <input
                      onChange={(e) => setRememberMe(e.target.checked)}
                      checked={rememberMe}
                      id="remember"
                      aria-describedby="remember"
                      type="checkbox"
                      className="w-4 h-4 border border-gray-300 rounded bg-gray-50 focus:ring-3 focus:ring-primary-300 dark:bg-gray-700 dark:border-gray-600 dark:focus:ring-primary-600 dark:ring-offset-gray-800"
                      required=""
                    ></input>
                  </div>
                  <div className="ml-3 text-sm">
                    <label
                      htmlFor="remember"
                      className="text-gray-500 dark:text-gray-300"
                    >
                      Se souvenir de moi
                    </label>
                  </div>
                </div>
              </div>
              <button
                // type="submit"
                onClick={onSubmit}
                // onKeyDown={(e) => { if (e.key === 'Enter') onSubmit(); }}
                style={{
                  background: "linear-gradient(to right, #eb6820, #fd9358)",
                }}
                className={`w-full text-white ${loader
                  ? `bg-stone-700`
                  : ` focus:ring-4 focus:outline-none focus:ring-primary-300`
                  } transition ease-in-out font-medium rounded-lg text-sm px-5 py-3.5 text-center dark:bg-primary-600 dark:hover:bg-primary-700 dark:focus:ring-primary-800`}
              >
                {isLoading ? <ClipLoader size={"18px"} color="white" /> : `Se connecter`}
              </button>
              <div className="text-center ">
                <Link
                  className="font-medium text-white hover:underline dark:text-primary-500"
                  to={"/reset-password"}
                >
                  Mot de passe oublié ?
                </Link>
              </div>
              <h1 className=" text-center text-md  leading-tight tracking-tight pt-5 text-white  dark:text-white">
                Nouveau sur MAYA+ ?
              </h1>
              <button onClick={() => navigate('/signup')} className={`bg-teal-500 hover:bg-teal-600 flex items-center gap-3 justify-center w-full text-white focus:ring-4 focus:outline-none focus:ring-primary-300 transition ease-in-out font-medium rounded-lg text-sm px-5 py-3.5 text-center dark:bg-primary-600 dark:hover:bg-primary-700 dark:focus:ring-primary-800`}
              //  style={{
              //   background: "linear-gradient(to right, #eb6820, #fd9358)",
              // }} 
              >
                <FaPlay />
                S'inscrire pour 9,99 € par mois
              </button>
              {/* <p className="text-sm font-light text-gray-500 dark:text-gray-400">
                    Don’t have an account yet?{" "}
                    <Link
                      className="font-medium text-white hover:underline dark:text-primary-500"
                      to={"/signup"}
                    >
                      Sign up
                    </Link>
                  </p> */}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default SignIn;
